import { LoadingIndicator } from './LoadingIndicator';
import {
    LazySPItemsViewErrorComponent,
    LazySPItemsViewList,
    LazySPItemsViewNavigator,
    LazySPItemsViewRefreshComponent,
} from './spDocLibView';
import { RecentFiles, RecentFilesEmptyOrErrorWithNoSP } from './recentFiles';
import { FilesHubFRE } from './FilesHubFRE';
import { EndFilesHubLoadListDataPointWhenNotComplete } from 'owa-group-files-hub-store';
import { LightningId } from 'owa-lightning-v2';
import { observer } from 'mobx-react';
import * as React from 'react';

const classnames = require('classnames');
const styles = require('./FilesHub.scss');

export interface Props {
    className?: string;
}

@observer
export default class FilesHub extends React.Component<Props, {}> {
    public static defaultProps: Partial<Props> = {
        className: '',
    };

    componentWillUnmount() {
        EndFilesHubLoadListDataPointWhenNotComplete('filesHubUnMounted');
    }

    render(): JSX.Element {
        const { className } = this.props;

        return (
            <div className={classnames(styles.FilesHubWrapper, className)}>
                <LazySPItemsViewErrorComponent />
                <div className={styles.scrollablePane} data-is-scrollable={true}>
                    <RecentFilesEmptyOrErrorWithNoSP />
                    <RecentFiles />
                    <LoadingIndicator />
                    <div className={classnames(styles.sharePointWrapper)}>
                        <LazySPItemsViewList />
                    </div>
                    <LazySPItemsViewNavigator />
                    <LazySPItemsViewRefreshComponent />
                </div>
                <FilesHubFRE lid={LightningId.GroupFilesHubFRE} when={this.whenToTriggerLightup} />
            </div>
        );
    }

    private whenToTriggerLightup(lightup: () => void): void {
        setTimeout(() => lightup(), 2500);
    }
}
